// extracted by mini-css-extract-plugin
module.exports = {"containerPremiumModal":"styles_containerPremiumModal__5jILA","textLink":"styles_textLink__qeQlL","textIsBold":"styles_textIsBold__WCUx0"};